import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ApiError, apiBlob } from "../api";

export function useReceiptPhoto(receiptId: string | undefined, enabled: boolean) {
  const { data: blob, isLoading } = useQuery({
    queryKey: ["receipt-photo", receiptId],
    queryFn: async () => {
      try {
        return await apiBlob(`/receipts/${receiptId}/photo`);
      } catch (e) {
        if (e instanceof ApiError && e.status === 404) return null;
        throw e;
      }
    },
    enabled: enabled && !!receiptId,
    retry: false,
    staleTime: Infinity,
  });

  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) {
      setUrl(null);
      return;
    }
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob]);

  return { url, isLoading: enabled && isLoading };
}
